import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaRegHeart,
  FaRegUser,
} from "react-icons/fa";
import { BsCart } from "react-icons/bs";
import "../assets/styles/Header.css";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { BaseUrl } from "../config/api";

const Header = () => {
  const { toggleCart, cartItems } = useCart();
  const { wishlistItems } = useWishlist();
  const [announcementIndex, setAnnouncementIndex] = useState(0);
  const [announcements, setAnnouncements] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [categoryTypes, setCategoryTypes] = useState([]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch(`${BaseUrl}/marketing/getallcontents`);
        if (!response.ok) {
          console.error("Failed to fetch announcements:", response.status);
          return;
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          setAnnouncements(data.map((item) => item.content));
        }
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (announcements.length > 1) {
      const timer = setInterval(() => {
        setAnnouncementIndex((prev) => (prev + 1) % announcements.length);
      }, 3000);

      return () => clearInterval(timer);
    }
  }, [announcements]);

  useEffect(() => {
    const fetchCategoryTypes = async () => {
      try {
        const response = await fetch(`${BaseUrl}/categorytypes/allcategorytypes`);
        if (!response.ok) {
          console.error("Failed to fetch category types:", response.status);
          return;
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          const sorted = data
            .filter((type) => !type.isDeleted)
            .sort((a, b) => {
              const aOrder =
                typeof a.displayOrder === "number"
                  ? a.displayOrder
                  : Number.MAX_SAFE_INTEGER;
              const bOrder =
                typeof b.displayOrder === "number"
                  ? b.displayOrder
                  : Number.MAX_SAFE_INTEGER;
              if (aOrder !== bOrder) return aOrder - bOrder;
              return (a.typeName || "").localeCompare(b.typeName || "");
            });
          setCategoryTypes(sorted);
        }
      } catch (error) {
        console.error("Error fetching category types:", error);
      }
    };

    fetchCategoryTypes();
  }, []);

  const getCategoryPath = (typeName) => {
    const slug = typeName.toLowerCase().replace(/\s+/g, "-");
    if (slug === "home") return "/";
    if (slug === "new-collections" || slug === "newcollections") return "/new-collections";
    if (slug === "accessories") {
      return "/collections/accessories";
    }
    return `/collections/${slug}`;
  };

  const getCategoryLabel = (typeName) => {
    if (typeName === "Saree") return "Sarees";
    if (typeName.toLowerCase() === "newcollections" || typeName.toLowerCase() === "new collections") return "New Collections";
    if (typeName.toLowerCase() === "home") return "Home";
    return typeName;
  };

  return (
    <>
      {announcements.length > 0 && (
        <div className="announcement-bar">
          <div className="announcement-text">
            {announcements[announcementIndex] || "Free Shipment On Orders Over $ 150 AUD"}
          </div>
        </div>
      )}
      <header className="header">
        <div className="header-content container">
          <div className="main-header-row">
            <div className="logo-section">
              <Link to="/">
                <img src="/logo.jpg" alt="Varnamika" />
              </Link>
            </div>

            <div className="brand-section">
              <Link to="/" className="brand-name">
                Varnamika
              </Link>
            </div>

            <div className="header-actions">
              <Link to="/favourites">
                <button className="wishlist-btn">
                  <FaRegHeart />
                  {wishlistItems.length > 0 && (
                    <span className="header-wishlist-count">
                      {wishlistItems.length}
                    </span>
                  )}
                </button>
              </Link>
              <Link to="/my-account">
                <button className="account-btn">
                  <FaRegUser />
                </button>
              </Link>
              <button className="cart-btn" onClick={toggleCart}>
                <BsCart />
                {cartItems.length > 0 && (
                  <span className="header-cart-count">{cartItems.length}</span>
                )}
              </button>
            </div>

            <button
              className={`mobile-menu-btn ${isMobileMenuOpen ? "open" : ""}`}
              onClick={toggleMobileMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          <div className="nav-container">
            <nav className={`nav-menu ${isMobileMenuOpen ? "mobile-open" : ""}`}>
              {categoryTypes.map((type) => (
                <NavLink
                  key={type._id}
                  to={getCategoryPath(type.typeName)}
                  onClick={handleNavLinkClick}
                >
                  {getCategoryLabel(type.typeName)}
                </NavLink>
              ))}
            </nav>
            <div
              className={`mobile-menu-overlay ${isMobileMenuOpen ? "active" : ""
                }`}
              onClick={toggleMobileMenu}
            ></div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
